<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5 6V21H19V6H5Z" class="stroke-current" stroke-width="1.5" stroke-linejoin="round" />
    <path
      d="M10.2 10.3478V16M13.8 10.3478V16M3 6H21"
      class="stroke-current"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path d="M8 6L9.6445 3H14.3885L16 6H8Z" class="stroke-current" stroke-width="1.5" stroke-linejoin="round" />
  </svg>
</template>
